export const getGlobalSearchInput = (state) => state.globalSearch.globalSearchInput;
